import {
  Comparison,
  CredentialType,
  EmploymentType,
  Profession,
  TertiaryLevel,
  TertiaryResultType,
} from '@uac-au/advance-typings';

import { z } from 'zod';

export const employmentMatchingCriteriaSchema = z.discriminatedUnion('field', [
  z.object({
    field: z.literal('country'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('company'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('duration'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('industry'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('name'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('responsibilities'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('type'),
    value: z.nativeEnum(EmploymentType),
    comparison: z.nativeEnum(Comparison),
  }),
]);

export const professionalMatchingCriteriaSchema = z.discriminatedUnion('field', [
  z.object({
    field: z.literal('code'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('country'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('expiryDate'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('info'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  // handle _institution
  z.object({
    field: z.literal('institutionCode'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('institutionName'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('name'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('profession'),
    value: z.nativeEnum(Profession),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('registrationNumber'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('type'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('yearAwarded'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
]);

export const subjectMatchingCriteriaSchema = z.discriminatedUnion('field', [
  z.object({
    field: z.literal('code'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('country'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  // handle _institution
  z.object({
    field: z.literal('institutionCode'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('institutionName'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('learningOutcome'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('name'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('result'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('resultType'),
    value: z.nativeEnum(TertiaryResultType),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('yearComplete'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
]);

export const tertiaryMatchingCriteriaSchema = z.discriminatedUnion('field', [
  z.object({
    field: z.literal('code'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('completion'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('completionDate'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('country'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('cricos'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  // handle _institution
  z.object({
    field: z.literal('institutionCode'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('institutionName'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('intake'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('level'),
    value: z.nativeEnum(TertiaryLevel),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('location'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('name'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('result'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('resultType'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
  z.object({
    field: z.literal('stream'),
    value: z.string().trim().min(1),
    comparison: z.nativeEnum(Comparison),
  }),
]);

export const requiredCredentialSchema = z.discriminatedUnion('type', [
  z
    .object({
      ID: z.string().trim().min(1),
      type: z.literal(CredentialType.EMPLOYMENT),
      matchingCriteria: z.array(employmentMatchingCriteriaSchema),
    })
    .strict(),
  z
    .object({
      ID: z.string().trim().min(1),
      type: z.literal(CredentialType.PROFESSIONAL),
      matchingCriteria: z.array(professionalMatchingCriteriaSchema),
    })
    .strict(),
  z
    .object({
      ID: z.string().trim().min(1),
      type: z.literal(CredentialType.SUBJECT),
      matchingCriteria: z.array(subjectMatchingCriteriaSchema),
    })
    .strict(),
  z
    .object({
      ID: z.string().trim().min(1),
      type: z.literal(CredentialType.TERTIARY),
      matchingCriteria: z.array(tertiaryMatchingCriteriaSchema),
    })
    .strict(),
]);
